











































import Vue from 'vue';
import {API, getDesserts} from '@/api';
import AgregarEgreso from '@/components/egreso/AgregarEgreso.vue';
import AgregarPagos from '@/components/pagos/AgregarPagos.vue';

export default Vue.extend({
  components: { AgregarEgreso, AgregarPagos },
  data: () => ({
    headers: [
      // { text: 'Propietario', value: 'propietario.nombre' },
      // { text: 'Unidad', value: 'unidad.name' },
      { text: 'Proveedor', value: 'proveedor.name'},
      { text: 'Concepto', value: 'items.concepto.nombre' },
      { text: 'Fecha', value: 'fecha' },
      { text: 'Total', value: 'total' },
      { text: 'Status', value: 'pagoStatus' },
      { text: 'Adeudo', value: 'openTotal' },
      // { text: 'Banco', value: 'cuenta.banco' },
      // { text: 'Cuenta Banco', value: 'cuenta.numCuenta'},
    ],
    singleSelect: [],
    precision: 2,
    total: 0,
    egresos: [],
    loading: true,
    options: {itemsPerPage: 100},
    saldo: {},
    disabled: true,
  }),
  methods: {
    async loadData() {
      console.log('EgresoSeleccionada: ', this.singleSelect);
      try {
        this.loading = true;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const result = await this.$store.dispatch('getEgresoList', {admin, condo, options: this.options});
        console.debug('getEgresoList result: %o', result);
        this.total = result.totalElements;
        this.egresos = result.data.content;
        console.debug('EGRESOS_LIST_prueba: %o', result.data.content);
        console.debug('EGRESOS_LIST: %o', this.egresos);
        this.saldoCondo();
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
    },
    async saldoCondo() {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const result = await this.$store.dispatch('getSaldoCondominio', {admin, condo});
      console.log('Prueba Saldo', result);
      this.saldo = result.data;
    },
    async pageEventHandler(page) { // cargar mas registros
      this.loadData();
    },
    async reloadGrid(event) {
      this.loadData();
    },
    fecha(item) {
      const fecha = this.$moment(item.periodo).format('DD/MM/YYYY');
      return fecha;
    },
  },
  watch: {
    singleSelect() {
      if (this.singleSelect.length !== 0) {
        this.disabled = false;
      }
    },
  },
});
